<template>
  <div
      ref="button"
      class="floating-button"
      :style="buttonStyle"
      @click="onClick"
      @touchstart="onTouchStart"
      @touchmove.prevent="onTouchMove"
      @touchend="onTouchEnd"
  >
    <Icon class="add-icon" name="plus" />
  </div>
</template>

<script>
import {Icon} from "vant";

export default {
  components: {Icon},
  props: {
    defaultX: {
      type: Number,
      default: window.innerWidth - 64 - 17 // 默认右下角，距离右边和底部20px
    },
    defaultY: {
      type: Number,
      default: window.innerHeight - 64 - 17 // 默认右下角，距离右边和底部20px
    },
    margin: {
      type: Number,
      default: 17 // 离屏幕边缘的间距
    }
  },
  data() {
    return {
      startX: 0,
      startY: 0,
      buttonX: this.defaultX,
      buttonY: this.defaultY,
      isDragging: false
    };
  },
  computed: {
    buttonStyle() {
      return {
        position: 'fixed',
        left: `${this.buttonX}px`,
        top: `${this.buttonY}px`,
        width: '64px',
        height: '64px',
        borderRadius: '50%',
        textAlign: 'center',
        lineHeight: '64px',
        color: 'white',
        cursor: 'pointer'
      };
    }
  },
  methods: {
    onClick() {
      this.$emit("click")
    },
    onTouchStart(event) {
      this.startX = event.touches[0].clientX - this.buttonX;
      this.startY = event.touches[0].clientY - this.buttonY;
      this.isDragging = true;
    },
    onTouchMove(event) {
      if (this.isDragging) {
        this.buttonX = event.touches[0].clientX - this.startX;
        this.buttonY = event.touches[0].clientY - this.startY;
      }
    },
    onTouchEnd() {
      this.isDragging = false;
      // 自动吸附到屏幕的左侧或右侧，并保持固定的间距
      if (this.buttonX + 32 < window.innerWidth / 2) { // 32是按钮宽度的一半
        this.buttonX = this.margin;
      } else {
        this.buttonX = window.innerWidth - 64 - this.margin;
      }

      // 保证按钮不超出屏幕顶部或底部
      if (this.buttonY < this.margin) {
        this.buttonY = this.margin;
      } else if (this.buttonY > window.innerHeight - 64 - this.margin) {
        this.buttonY = window.innerHeight - 64 - this.margin;
      }
    }
  }
};
</script>

<style scoped>
.floating-button {
  background: rgba(10, 136, 255, 1);
  box-shadow: 0 11px 20px  rgba(10, 136, 255, 0.38);
}
.add-icon {
  color: white;
  font-size: 18px;
}
</style>



